import { WinnerToasterProps } from "@/@types/AppTypes";
import * as animationData from "../assets/Animation - 1704992648732.json";
import Lottie from "react-lottie";
import { MapPin, Trophy } from "@phosphor-icons/react";

export default function LastJackpotWinnerToaster({
  name,
  document,
  price,
  location,
  selected_color,
  tickets,
  dismiss,
}: WinnerToasterProps) {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const isMultiple =
    Array.isArray(name) &&
    Array.isArray(selected_color) &&
    Array.isArray(document) &&
    Array.isArray(location) &&
    Array.isArray(price) &&
    Array.isArray(tickets);

  const renderWinnerElement = (index: number) => {
    const colorIndex = isMultiple ? selected_color[index] : selected_color;
    const colors = [
      "text-[#DDBE55]",
      "text-[#39B54A]",
      "text-[#0078E8]",
      "text-[#EE7219]",
    ];
    const winnerColor = colorIndex <= 3 ? colors[colorIndex] : "";
    return (
      <div
        key={index}
        className={`flex w-full items-center justify-between px-2 lg:px-[16px] py-1 lg:py-[8px] relative flex-1 grow rounded-[12px] border border-solid border-[#e6e6e6] mb-2`}
      >
        <div className="inline-flex items-center gap-[1px] lg:gap-[4px] relative flex-[0_0_auto]">
          <div className="relative w-fit font-medium text-[#454545] text-[9px] lg:text-[16px] tracking-[0] leading-[normal] whitespace-nowrap">
            {isMultiple ? name[index] : name}
          </div>
          <div className="inline-flex flex-col items-center justify-center gap-[8px] px-1 lg:px-[8px] py-[6px] relative flex-[0_0_auto] bg-white rounded-[500px]">
            <div className="relative w-fit mt-[-2.00px] [font-family:'Inter-Medium',Helvetica] font-medium text-[#006e2c] text-[9px] lg:text-[14px] text-center tracking-[0] leading-[normal]">
              {isMultiple ? document[index] : document}
            </div>
          </div>
          <div className="flex flex-row px-2 py-1 gap-1 border border-[#E4E4E4] rounded-full">
            <MapPin className="w-4 h-4 lg:w-5 lg:h-5 text-[#949494]" />
            <span className="uppercase text-[#949494] text-xs lg:text-sm">
              {isMultiple
                ? location[index]
                  ? location[index]
                  : "XX"
                : location
                ? location
                : "XX"}
            </span>
          </div>
          {colorIndex <= 3 ? (
            <div className="w-6 h-6">
              <svg
                className={`w-full h-full ${winnerColor} fill-current`}
                viewBox="0 0 300 300"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M104.723 16.9641C93.8074 17.0283 83.3569 21.3931 75.638 29.112C67.9192 36.8308 63.5544 47.2814 63.4901 58.1972L63.4184 64.3284L57.341 64.3464C46.7271 64.8252 36.7066 69.3786 29.365 77.0589C22.0234 84.7392 17.9262 94.9548 17.9262 105.58C17.9262 116.204 22.0234 126.42 29.365 134.1C36.7066 141.78 46.7271 146.334 57.341 146.813L142.21 146.92C143.215 146.913 144.178 146.51 144.889 145.799C145.6 145.088 146.003 144.125 146.01 143.12L146.01 58.251C145.96 47.3165 141.594 36.8442 133.862 29.1122C126.13 21.3803 115.658 17.0143 104.723 16.9641Z"
                  fill="currentColor"
                />
                <path
                  d="M104.723 283.036C93.8074 282.972 83.3569 278.607 75.638 270.888C67.9192 263.169 63.5544 252.719 63.4901 241.803L63.4184 235.672L57.341 235.654C46.7271 235.175 36.7066 230.621 29.365 222.941C22.0234 215.261 17.9262 205.045 17.9262 194.42C17.9262 183.796 22.0234 173.58 29.365 165.9C36.7066 158.22 46.7271 153.666 57.341 153.187L142.21 153.08C143.215 153.087 144.178 153.49 144.889 154.201C145.6 154.912 146.003 155.875 146.01 156.88L146.01 241.749C145.96 252.683 141.594 263.156 133.862 270.888C126.13 278.62 115.658 282.986 104.723 283.036Z"
                  fill="currentColor"
                />
                <path
                  d="M195.1 16.9641C206.016 17.0283 216.466 21.3931 224.185 29.112C231.904 36.8308 236.269 47.2814 236.333 58.1972L236.405 64.3284L242.482 64.3464C253.096 64.8252 263.117 69.3786 270.458 77.0589C277.8 84.7392 281.897 94.9548 281.897 105.58C281.897 116.204 277.8 126.42 270.458 134.1C263.117 141.78 253.096 146.334 242.482 146.813L157.614 146.92C156.608 146.913 155.645 146.51 154.934 145.799C154.223 145.088 153.82 144.125 153.813 143.12L153.813 58.251C153.863 47.3165 158.229 36.8442 165.961 29.1122C173.693 21.3803 184.165 17.0143 195.1 16.9641Z"
                  fill="currentColor"
                />
                <path
                  d="M195.1 283.036C206.016 282.972 216.466 278.607 224.185 270.888C231.904 263.169 236.269 252.719 236.333 241.803L236.405 235.672L242.482 235.654C253.096 235.175 263.117 230.621 270.458 222.941C277.8 215.261 281.897 205.045 281.897 194.42C281.897 183.796 277.8 173.58 270.458 165.9C263.117 158.22 253.096 153.666 242.482 153.187L157.614 153.08C156.608 153.087 155.645 153.49 154.934 154.201C154.223 154.912 153.82 155.875 153.813 156.88L153.813 241.749C153.863 252.683 158.229 263.156 165.961 270.888C173.693 278.62 184.165 282.986 195.1 283.036Z"
                  fill="currentColor"
                />
              </svg>
            </div>
          ) : (
            <div className="flex flex-row px-2 py-1 gap-1 border border-[#E4E4E4] rounded-full">
              <Trophy className="w-4 h-4 lg:w-5 lg:h-5 text-[#949494]" />
              <span className="uppercase text-[#949494] text-xs lg:text-sm">
                {colorIndex === 4
                  ? "hora"
                  : colorIndex === 5
                  ? "dia"
                  : colorIndex === 6
                  ? "semana"
                  : colorIndex === 7
                  ? "mes"
                  : "ano"}
              </span>
            </div>
          )}
        </div>
        <div className="inline-flex items-center gap-1 lg:gap-[10px] px-2 lg:px-[12px] py-[4px] relative flex-[0_0_auto] bg-[#02a2441a] rounded-full">
          <div className="relative w-fit mt-[-1.00px] font-medium text-[#03953f] text-[9px] lg:text-[15px] tracking-[0] leading-[normal] whitespace-nowrap">
            +{" "}
            {new Intl.NumberFormat("pt-br", {
              style: "currency",
              currency: "BRL",
            }).format(Number(isMultiple ? price[index] : price))}
          </div>
        </div>
      </div>
    );
  };

  const renderTicketsInfo = () => {
    const durationTypes = ["HORA", "DIA", "SEMANA", "MES", "ANO"];
    if (!Array.isArray(selected_color)) return null;
    return selected_color.map((color, index) => {
      if (color > 3 && tickets[index]) {
        return (
          <span key={index} className="mt-2 text-2xl font-semibold text-[#3A3A3A]">
            Ticket sorteado Pix{durationTypes[color - 4]}: {tickets[index]}
          </span>
        );
      }
      return null;
    });
  };

  const renderWinnerElements = () => {
    if (isMultiple) {
      return name.map((_, index) => renderWinnerElement(index));
    } else {
      return renderWinnerElement(0);
    }
  };

  return (
    <div
      className={`flex flex-col w-[350px] lg:w-[568px] max-h-[70vh] lg:scrollbarLG items-center gap-1 lg:gap-[12px] px-3 lg:px-[15px] py-2 relative bg-hdgraybranco rounded-[16px] border-2 border-solid border-[#02a244] shadow-[0px_4px_27px_#00000040] overflow-y-auto`}
    >
      <div className="w-[120px] lg:w-[264px] h-[110px] lg:h-[182px]">
        <Lottie options={defaultOptions} />
      </div>
      <span className="text-2xl font-semibold text-[#3A3A3A]">
        Sorteio finalizado
      </span>
      <span className="text-[50px] font-bold text-[#03A344]">
        {Array.isArray(name) && name.length > 1 ? "Vencedores" : "Vencedor"}
      </span>
      {renderTicketsInfo()}
      {renderWinnerElements()}
      <button
        className="px-6 py-2 border-2 border-[#03A344] text-[#03A344] text-[14px] font-medium rounded-lg"
        onClick={() => dismiss}
      >
        Fechar
      </button>
    </div>
  );
}
